module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Regular-9087338f0290b38d6129745df256b680.woff";